import { CarFront, Clock, Droplets, Landmark, Snowflake, UtensilsCrossed, Wifi, Zap } from "lucide-react";
import { AMENITIES, IMAGES } from "@/constants/hotelData";
import Reveal from "@/components/Reveal";

const ICONS = {
  clock: Clock,
  utensils: UtensilsCrossed,
  wifi: Wifi,
  banquet: Landmark,
  zap: Zap,
  car: CarFront,
  snow: Snowflake,
  droplets: Droplets,
};

export default function Amenities() {
  return (
    <section id="amenities" className="py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.34em] text-gold sm:text-xs">
            Royal Experiences
          </p>
          <h2 className="max-w-2xl font-serif text-3xl tracking-tight text-cream sm:text-4xl lg:text-[2.75rem]">
            Everything a weary traveller deserves
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <Reveal className="sm:col-span-2 lg:row-span-2">
            <div className="group relative h-full min-h-[320px] overflow-hidden rounded-2xl border border-gold/15">
              <img
                src={IMAGES.dining}
                alt="Dining at Hotel Raj"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8">
                <UtensilsCrossed className="mb-3 h-7 w-7 text-gold" />
                <h3 className="font-serif text-2xl text-cream">Multi-Cuisine Dining</h3>
                <p className="mt-2 max-w-sm text-sm font-light leading-relaxed text-stone-300">
                  Bihari classics, North Indian favourites and familiar comfort
                  food — served hot, morning to midnight.
                </p>
              </div>
            </div>
          </Reveal>

          {AMENITIES.filter((a) => a.icon !== "utensils").map((a, i) => {
            const Icon = ICONS[a.icon] || Clock;
            return (
              <Reveal key={a.title} delay={0.06 * (i + 1)} className="h-full">
                <div
                  className="h-full rounded-2xl border border-gold/15 bg-ink/50 p-6 transition-all duration-300 hover:border-gold/40 hover:bg-ink/80"
                  data-testid={`amenity-card-${a.icon}`}
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-4 font-serif text-lg text-cream">{a.title}</h3>
                  <p className="mt-1.5 text-sm font-light leading-relaxed text-stone-400">{a.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
